<template>
  <div>
    <ocpc type="setList" />
  </div>
</template>
<script>
import Ocpc from './components/OcpcMain'
export default {
  components: {
    Ocpc
  }
}
</script>
